
const dateFormat = "YYYY-MM-DD";

export {dateFormat};